/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum CountryCode {
  AO = "AO",
  AR = "AR",
  AU = "AU",
  AT = "AT",
  AZ = "AZ",
  BS = "BS",
  BH = "BH",
  BE = "BE",
  BU = "BU",
  BA = "BA",
  BR = "BR",
  BN = "BN",
  BG = "BG",
  KH = "KH",
  CM = "CM",
  CA = "CA",
  KY = "KY",
  CL = "CL",
  CN = "CN",
  CO = "CO",
  CR = "CR",
  HR = "HR",
  CY = "CY",
  CZ = "CZ",
  DK = "DK",
  EG = "EG",
  FI = "FI",
  FR = "FR",
  GE = "GE",
  DE = "DE",
  GB = "GB",
  GH = "GH",
  GR = "GR",
  HK = "HK",
  HU = "HU",
  IS = "IS",
  IN = "IN",
  ID = "ID",
  IE = "IE",
  IL = "IL",
  IT = "IT",
  JP = "JP",
  JE = "JE",
  KE = "KE",
  KR = "KR",
  LV = "LV",
  LB = "LB",
  LU = "LU",
  MO = "MO",
  MY = "MY",
  MT = "MT",
  MU = "MU",
  MX = "MX",
  MJ = "MJ",
  NL = "NL",
  NONE = "NONE",
  NZ = "NZ",
  NG = "NG",
  NO = "NO",
  OM = "OM",
  PK = "PK",
  PH = "PH",
  PL = "PL",
  PT = "PT",
  PR = "PR",
  QA = "QA",
  RO = "RO",
  RU = "RU",
  BL = "BL",
  RI = "RI",
  SI = "SI",
  SL = "SL",
  SG = "SG",
  SK = "SK",
  ZA = "ZA",
  ES = "ES",
  LK = "LK",
  SE = "SE",
  CH = "CH",
  TW = "TW",
  TH = "TH",
  TT = "TT",
  TR = "TR",
  UG = "UG",
  UA = "UA",
  AE = "AE",
  UK = "UK",
  US = "US",
  VE = "VE",
  VN = "VN",
}

export const CountryCodeDisplay: Record<CountryCode, string> = {
  [CountryCode.AO]: "Angola",
  [CountryCode.AR]: "Argentina",
  [CountryCode.AU]: "Australia",
  [CountryCode.AT]: "Austria",
  [CountryCode.AZ]: "Azerbaijan",
  [CountryCode.BS]: "Bahamas",
  [CountryCode.BH]: "Bahrain",
  [CountryCode.BE]: "Belgium",
  [CountryCode.BU]: "Bermuda",
  [CountryCode.BA]: "Bosnia and Herzegovina",
  [CountryCode.BR]: "Brazil",
  [CountryCode.BN]: "Brunei Darussalam",
  [CountryCode.BG]: "Bulgaria",
  [CountryCode.KH]: "Cambodia",
  [CountryCode.CM]: "Cameroon",
  [CountryCode.CA]: "Canada",
  [CountryCode.KY]: "Cayman Islands",
  [CountryCode.CL]: "Chile",
  [CountryCode.CN]: "China",
  [CountryCode.CO]: "Colombia",
  [CountryCode.CR]: "Costa Rica",
  [CountryCode.HR]: "Croatia",
  [CountryCode.CY]: "Cyprus",
  [CountryCode.CZ]: "Czech Republic",
  [CountryCode.DK]: "Denmark",
  [CountryCode.EG]: "Egypt",
  [CountryCode.FI]: "Finland",
  [CountryCode.FR]: "France",
  [CountryCode.GE]: "Georgia",
  [CountryCode.DE]: "Germany",
  [CountryCode.GB]: "Great Britain",
  [CountryCode.GH]: "Ghana",
  [CountryCode.GR]: "Greece",
  [CountryCode.HK]: "Hong Kong",
  [CountryCode.HU]: "Hungary",
  [CountryCode.IS]: "Iceland",
  [CountryCode.IN]: "India",
  [CountryCode.ID]: "Indonesia",
  [CountryCode.IE]: "Ireland",
  [CountryCode.IL]: "Israel",
  [CountryCode.IT]: "Italy",
  [CountryCode.JP]: "Japan",
  [CountryCode.JE]: "Jersey",
  [CountryCode.KE]: "Kenya",
  [CountryCode.KR]: "Korea; Republic Of (South)",
  [CountryCode.LV]: "Latvia",
  [CountryCode.LB]: "Lebanon",
  [CountryCode.LU]: "Luxembourg",
  [CountryCode.MO]: "Macau",
  [CountryCode.MY]: "Malaysia",
  [CountryCode.MT]: "Malta",
  [CountryCode.MU]: "Mauritius",
  [CountryCode.MX]: "Mexico",
  [CountryCode.MJ]: "Montenegro",
  [CountryCode.NL]: "Netherlands",
  [CountryCode.NONE]: "- None Specified -",
  [CountryCode.NZ]: "New Zealand",
  [CountryCode.NG]: "Nigeria",
  [CountryCode.NO]: "Norway",
  [CountryCode.OM]: "Oman",
  [CountryCode.PK]: "Pakistan",
  [CountryCode.PH]: "Philippines",
  [CountryCode.PL]: "Poland",
  [CountryCode.PT]: "Portugal",
  [CountryCode.PR]: "Puerto Rico",
  [CountryCode.QA]: "Qatar",
  [CountryCode.RO]: "Romania",
  [CountryCode.RU]: "Russian Federation",
  [CountryCode.BL]: "Saint Barthélemy",
  [CountryCode.RI]: "Serbia",
  [CountryCode.SI]: "Slovenia",
  [CountryCode.SL]: "Sierra Leone",
  [CountryCode.SG]: "Singapore",
  [CountryCode.SK]: "Slovakia",
  [CountryCode.ZA]: "South Africa",
  [CountryCode.ES]: "Spain",
  [CountryCode.LK]: "Sri Lanka",
  [CountryCode.SE]: "Sweden",
  [CountryCode.CH]: "Switzerland",
  [CountryCode.TW]: "Taiwan",
  [CountryCode.TH]: "Thailand",
  [CountryCode.TT]: "Trinidad and Tobago",
  [CountryCode.TR]: "Turkey",
  [CountryCode.UG]: "Uganda",
  [CountryCode.UA]: "Ukraine",
  [CountryCode.AE]: "United Arab Emirates",
  [CountryCode.UK]: "United Kingdom",
  [CountryCode.US]: "United States",
  [CountryCode.VE]: "Venezuela",
  [CountryCode.VN]: "Vietnam",
};
